import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatSnackBar } from '@angular/material';
import { Pessoa } from 'app/main/content/shared/models/pessoa.model';
import { Plano } from 'app/main/content/shared/models/plano.model';
import { PlanoCategoria } from 'app/main/content/shared/models/planoCategoria.model';
import { PlanoCategoriaSituacao } from 'app/main/content/shared/models/planoCategoriaSituacao.model';
import { PlanoSituacao } from 'app/main/content/shared/models/planoSituacao.model';
import { ViewModelFiltroWebBloqueioExcecao } from 'app/main/content/shared/models/ViewModelFiltroWebBloqueioExcecao.model';
import { ViewModelProcessoWebBloqueioExcecao } from 'app/main/content/shared/models/ViewModelProcessoWebBloqueioExcecao.model';
import { WebBloqueioExcecao } from 'app/main/content/shared/models/webBloqueioExcecao.model';
import { WebIntegrFuncionalidade } from 'app/main/content/shared/models/webIntegrFuncionalidade.model';
import { WebBloqueioExcecaoService } from 'app/main/content/shared/services/webBloqueioExcecao.service';
import { LoginStore } from 'app/main/content/shared/store/login.store';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-modal-cadastro-excecao',
  templateUrl: './modal-cadastro-excecao.component.html',
  styleUrls: ['./modal-cadastro-excecao.component.scss']
})
export class ModalCadastroExcecaoComponent implements OnInit {
  selectedPlano: number;
  lista_Plano: Plano[] = [];
  viewModelProcessoWebBloqueioExcecao: ViewModelProcessoWebBloqueioExcecao = new ViewModelProcessoWebBloqueioExcecao();
  viewModelFiltroWebBloqueioExcecao: ViewModelFiltroWebBloqueioExcecao = new ViewModelFiltroWebBloqueioExcecao();
  lista_Funcionalidades: WebIntegrFuncionalidade[] = [];
  selectedFuncionalidade: number;
  lista_Categoria: PlanoCategoria[] = [];
  selectedCategoria: number;
  lista_Situacao: PlanoCategoriaSituacao[] = [];
  selectedSituacao: number;
  nmTexto: string = '';
  nrMatricula: string = '';


  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private loginStore: LoginStore,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private webBloqueioExcecaoService: WebBloqueioExcecaoService,) { }

  ngOnInit(): void {
    this.loadPlano();
    // this.loadSituacao();
    this.loadFuncionalidades();
    this.loadCategorias();


    // ✅ MODO EDIÇÃO
    if (this.data && this.data.modo === 'editar' && this.data.objeto) {
      const obj = this.data.objeto;

      // IDs
      this.selectedPlano = obj.idPlano;
      this.selectedFuncionalidade = obj.idFuncionalidade;
      this.selectedCategoria = obj.idPlanoCategoria;
      this.selectedSituacao = obj.idPlanoSituacao;

      // Outros campos
      this.nrMatricula = obj.nrMatricula;
      this.nmTexto = obj.nmMensagem;
    }
  }
  onPlanoChange() {
    console.log('Plano mudou:', this.selectedPlano);
    // lógica que você já tem
  }

  loadPlano() {
    this.webBloqueioExcecaoService.retornaListaComboPlanos().subscribe(plano => {
      this.lista_Plano = plano.filter(p => p.idPlano !== 0)
        .sort((a, b) => a.idPlano - b.idPlano);

      this.loaded.plano = true;
      this.trySetEdicao();
    });
  }
  loadFuncionalidades() {
    this.webBloqueioExcecaoService.retornaListaComboFuncionalidades()
      .subscribe((res) => {
        this.lista_Funcionalidades = res.sort((a, b) => a.idFuncionalidade - b.idFuncionalidade);
        this.loaded.funcionalidade = true;
        this.trySetEdicao();
      }, error => {
        console.error('Erro ao carregar funcionalidades', error);
      });
  }
  loadCategorias() {
    this.webBloqueioExcecaoService.retornaListaComboCategorias()
      .subscribe((res) => {
        this.lista_Categoria = res.sort((a, b) => a.idCategoria - b.idCategoria);

        this.loaded.categoria = true;
        this.trySetEdicao();
      });
  }
// loadSituacao() {
//   this.webBloqueioExcecaoService.retornaListaComboSituacao()
//     .subscribe((res) => {
//       this.lista_Situacao = res.sort((a, b) => a.idSituacao - b.idSituacao);

//       this.loaded.situacao = true;
//       this.trySetEdicao();
//     });
// }
  onCategoriaChange() {
    this.selectedSituacao = null; // limpa seleção anterior
    this.loadSituacaoPorCategoria(this.selectedCategoria);
  }
  loadSituacaoPorCategoria(idCategoria: number) {
    this.loaded.situacao = false;

    if (!idCategoria) {
      this.lista_Situacao = [];
      return;
    }

    this.webBloqueioExcecaoService
      .retornaListaComboSituacaoPorCategoria(idCategoria)
      .subscribe((res) => {
        this.lista_Situacao = res.sort((a, b) => a.idSituacao - b.idSituacao);
        this.loaded.situacao = true;
        this.trySetEdicao();
      });
  }
  criaMensagem() {

    const bloqueio = new WebBloqueioExcecao();

    bloqueio.idSeq = 0;

    // ✅ Só seta se existir
    if (this.selectedFuncionalidade) {
      bloqueio.funcionalidade = new WebIntegrFuncionalidade();
      bloqueio.funcionalidade.idFuncionalidade = this.selectedFuncionalidade;
    }

    if (this.selectedPlano) {
      bloqueio.plano = new Plano();
      bloqueio.plano.idPlano = this.selectedPlano;
    }

    if (this.selectedCategoria) {
      bloqueio.planoCategoria = new PlanoCategoria();
      bloqueio.planoCategoria.idCategoria = this.selectedCategoria;
    }

    if (this.selectedSituacao) {
      bloqueio.planoSituacao = new PlanoSituacao();
      bloqueio.planoSituacao.idSituacao = this.selectedSituacao;
    }

    // Campos opcionais
    bloqueio.nrMatricula = this.nrMatricula || null;
    bloqueio.nmMensagem = this.nmTexto || null;

    bloqueio.icBloqueio = 'S';
    bloqueio.dataBloqueio = new Date();

    this.webBloqueioExcecaoService.criarBloqueioExcecao(bloqueio)
      .subscribe(
        () => {
          Swal.fire({
            icon: 'success',
            title: 'Sucesso!',
            text: 'Mensagem cadastrada com sucesso!',
            confirmButtonColor: '#630a0c'
          });

          this.dialog.closeAll();
        },
        error => {
          console.error(error);

          Swal.fire({
            icon: 'error',
            title: 'Erro!',
            text: 'Erro ao salvar mensagem.',
            confirmButtonColor: '#630a0c'
          });
        }
      );
  }
  setValoresEdicao() {
    if (this.data && this.data.modo === 'editar' && this.data.objeto) {
      const obj = this.data.objeto;

      this.selectedPlano = obj.idPlano;
      this.selectedFuncionalidade = obj.idFuncionalidade;
      this.selectedCategoria = obj.idCategoria;
      this.selectedSituacao = obj.idSituacao;

      this.nrMatricula = obj.nrMatricula || '';
      this.nmTexto = obj.nmMensagem;
    }
  }
  salvarOuEditar() {

    if (!this.selectedFuncionalidade) {
      Swal.fire({
        icon: 'warning',
        title: 'Atenção!',
        text: 'Selecione uma funcionalidade antes de salvar.',
        confirmButtonColor: '#630a0c'
      });
      return;
    }

    if (this.data && this.data.modo === 'editar') {
      this.editar();
    } else {
      this.criaMensagem();
    }
  }
  editar() {
    const bloqueio = new WebBloqueioExcecao();

    bloqueio.idSeq = this.data.objeto.idSeq;

    if (this.selectedFuncionalidade) {
      bloqueio.funcionalidade = new WebIntegrFuncionalidade();
      bloqueio.funcionalidade.idFuncionalidade = this.selectedFuncionalidade;
    }

    if (this.selectedPlano) {
      bloqueio.plano = new Plano();
      bloqueio.plano.idPlano = this.selectedPlano;
    }

    if (this.selectedCategoria) {
      bloqueio.planoCategoria = new PlanoCategoria();
      bloqueio.planoCategoria.idCategoria = this.selectedCategoria;
    }

    if (this.selectedSituacao) {
      bloqueio.planoSituacao = new PlanoSituacao();
      bloqueio.planoSituacao.idSituacao = this.selectedSituacao;
    }

    bloqueio.nrMatricula = this.nrMatricula || null;
    bloqueio.nmMensagem = this.nmTexto || null;

    // ✅ AQUI ESTÁ O QUE FALTA
    bloqueio.dataBloqueio = new Date();

    this.webBloqueioExcecaoService.editar(bloqueio)
      .subscribe(
        () => {
          Swal.fire({
            icon: 'success',
            title: 'Atualizado!',
            text: 'Mensagem atualizada com sucesso!',
            confirmButtonColor: '#630a0c'
          });

          this.dialog.closeAll();
        },
        error => {
          console.error(error);
        }
      );
  }
  clear() {
    this.selectedFuncionalidade = undefined;
    this.selectedCategoria = undefined;
    this.selectedPlano = undefined;
    this.selectedSituacao = undefined;
    this.nrMatricula = '';
  }

  loaded = {
    plano: false,
    funcionalidade: false,
    categoria: false,
    situacao: false
  };
  trySetEdicao() {
    if (
      this.loaded.plano &&
      this.loaded.funcionalidade &&
      this.loaded.categoria &&
      this.loaded.situacao
    ) {
      this.setValoresEdicao();
    }
  }
}